<template>
    <div :class="{'paused':!isActive && isFinalized,'to-finalize':!isFinalized}" class="configuration">
        <div class="logo-container">
            <img :src="iconPath"/>
        </div>
        <div class="infos">
            <div class="name">{{ infos.name }}</div>
            <div class="desc">
                <span class="mode"><font-awesome-icon :icon="modeIcon" :rotation="modeIconRotation"
                                                      fixed-width></font-awesome-icon></span><span class="short-desc">{{ infos.shortDesc }}</span>
            </div>
        </div>
        <div class="state">
            <div @click="handleDelete" class="action-btn" v-if="!isActive">
                <font-awesome-icon icon="trash"></font-awesome-icon>
                <div class="tooltip">
                    <span class="warning">
                        Supprimer le connecteur
                    </span>

                </div>
            </div>

            <div :class="{disabled:!isFinalized}" @click="forceSync" class="action-btn" v-if="infos.cron">
                <font-awesome-icon :spin="isSpinning" icon="sync-alt"></font-awesome-icon>
                <div class="tooltip">
                    <span class="cron" v-if="infos.cron">
                        <font-awesome-icon icon="sync-alt"></font-awesome-icon>
                        <span>{{ cronToReadable }}</span>
                    </span>
                    <p v-if="isFinalized">Cliquez pour effectuer la synchronisation</p>
                </div>
            </div>
            <div class="action-btn disabled" v-else></div>

            <router-link :to="{name:'pluginEdit',params:{id:configuration.id}}" class="action-btn" tag="div">
                <font-awesome-icon icon="cog"></font-awesome-icon>
                <div class="tooltip">
                    <span class="warning">
                        Configurer le connecteur
                    </span>

                </div>
            </router-link>

            <div @click="handleActivation" class="action-btn" v-if="isFinalized">
                <template v-if="isActive">
                    <font-awesome-icon icon="play"></font-awesome-icon>
                    <div class="tooltip">
                    <span class="warning">
                        Le plugin est activé. Cliquez pour le mettre en pause.
                    </span>

                    </div>
                </template>
                <template v-else>
                    <font-awesome-icon icon="pause"></font-awesome-icon>
                    <div class="tooltip">
                    <span class="warning">
                        Le plugin est en pause. Cliquez pour l'activer.
                    </span>

                    </div>
                </template>


            </div>
            <router-link :to="{name:'pluginEdit',params:{id:configuration.id}}" class="action-btn" tag="div" v-else>
                <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                <div class="tooltip">
                    <span class="warning">
                        La configuration de ce connecteur n'est pas complète. Merci de la terminer pour l'activer.
                    </span>

                </div>
            </router-link>
        </div>
        <div class="lock-mask" :class="{show:lock}">
            <LoadingLight :id="'lock-'+configuration.id" :show="true" :overlay="false" color="#FFFFFF"></LoadingLight>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    import {mapActions} from 'vuex'

    import cronstrue from 'cronstrue/dist/cronstrue-i18n'
    import LoadingLight from "../ui/LoadingLight";

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {LoadingLight},
        computed: {
            iconPath() {
                return '/static/plugins/icons/' + this.infos.pluginId + '.svg'
            },
            modeIcon() {
                switch (this.infos.mode) {
                    case 'Import':
                        return 'long-arrow-alt-down'
                    case 'Export':
                        return 'long-arrow-alt-up'
                    case 'Synchronization':
                        return 'exchange-alt'
                }
            },
            modeIconRotation() {
                if (this.infos.mode == 'Synchronization') {
                    return 90
                }
                return null

            },
            cronToReadable() {
                return cronstrue.toString(this.infos.cron, {locale: "fr"});
            }
        },
        created: function () {

        },
        data() {
            return {
                isSpinning: false,
                lock: false
            }
        },
        destroyed: function () {

        },
        methods: {
            ...mapActions({
                activateConfiguration: 'Plugins/activateConfiguration',
                synchronizeConfiguration: 'Plugins/synchronizeConfiguration',
                deleteConfiguration: 'Plugins/deleteConfiguration'
            }),

            handleActivation() {
                this.lock = true;
                this.activateConfiguration({id: this.configuration.id, activation: !this.isActive}).then(response => {
                    this.$emit('itemAction')
                    this.hideLock()
                }).catch(error => {
                    console.warn('ERROR', error)
                    this.hideLock()
                })
            },

            handleDelete(){
                window.App.$refs.confirm.show({
                    title: 'Suppression',
                    content: 'Etes-vous sûr de vouloir supprimer ce connecteur ?',
                    callbackYes: () => {
                        this.lock = true;
                        this.deleteConfiguration({id: this.configuration.id}).then(response => {
                            this.$emit('itemAction')
                            this.hideLock()
                        }).catch(error => {
                            console.warn('ERROR', error)
                            this.hideLock()
                        })
                    }

                });

            },

            hideLock(){
                setTimeout(() =>{
                    this.lock = false;
                },500)
            },

            forceSync() {
                if (this.isActive) {
                    this.isSpinning = true
                    this.synchronizeConfiguration({id: this.configuration.id}).then(response => {
                        setTimeout(() => {
                            this.isSpinning = false
                        }, 2600)

                    })
                        .catch(error => {
                            setTimeout(() => {
                                this.isSpinning = false
                            }, 2600)
                            this.addError(error.message)
                        })
                }
            }
        },
        mounted: function () {

        },
        name: '',
        props: {
            infos: {
                type: Object,
                required: true
            },
            provider: {
                type: Object,
                default: null
            },
            category: {
                type: Object,
                default: null
            },
            configuration: {
                type: Object,
                required: true
            },
            isActive: {
                type: Boolean,
                default: false
            },
            isFinalized: {
                type: Boolean,
                default: false
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .configuration {

        $bg-opacity: 0.15;

        background-color: rgba($success, $bg-opacity);
        display: flex;
        padding: 20px;
        position: relative;


        &:not(:last-child) {
            border-bottom: solid 1px rgba($main-color, 0.5);
        }

        &.paused {
            background-color: rgba($warning, $bg-opacity);
        }

        &.to-finalize {
            //background-image: linear-gradient(-45deg,rgba($error,0.4),rgba($warning,0.4));
            background-color: rgba($main-black, $bg-opacity);

            & > *:not(.state):not(.lock-mask) {
                opacity: 0.5;
            }
        }

        .logo-container {
            flex: 0 0 86px;
            padding-top: 10px;

            img {
                width: 66px;
            }
        }

        .infos {
            flex: 1 1 100%;
            overflow: hidden;

            .name {
                font-weight: 300;
                font-size: 46px;
                color: $main-black;
                text-transform: uppercase;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .desc {

                font-weight: 300;
                font-size: 16px;
                color: #6b6b6b;
                line-height: 24px;


                .mode {

                }

                .short-desc {

                }
            }
        }

        .state {
            flex: 0 0 (4 * 70px);
            display: flex;
            justify-content: flex-end;

            .action-btn {
                flex: 0 0 70px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: relative;


                & > .svg-inline--fa {
                    font-size: 1.7rem;
                    color: $main-color;

                    &.fa-play {
                        color: $success;
                    }

                    &.fa-pause, &.fa-exclamation-triangle {
                        color: $warning;
                    }

                    &.fa-trash{
                        color: $error;
                    }
                }

                &.disabled {
                    cursor: default;

                    & > .svg-inline--fa {
                        opacity: 0.5;
                    }
                }


                .tooltip {
                    position: absolute;
                    background: $main-black;
                    color: $main-white;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, 30px) scale(0, 0);
                    //width: 190px;
                    text-align: center;
                    padding: 15px;
                    opacity: 0;
                    pointer-events: none;
                    transition-duration: 150ms;
                    transform-origin: 50% -10px;
                    max-width: 200px;
                    min-width: 130px;
                    z-index: 100000;

                    .cron, .warning {
                        display: block;
                        white-space: nowrap;
                        font-size: 0.8rem;
                        font-weight: $semi-bold;

                        .svg-inline--fa {
                            margin-right: 5px;
                            font-weight: $extra-light;
                        }
                    }

                    .warning {
                        white-space: normal;
                    }

                    p {
                        display: block;
                        font-size: 0.6rem;
                        padding: 0 10px;
                        margin-bottom: 0;
                    }

                    &:before {
                        content: '';
                        width: 0;
                        height: 0;
                        border: 0 solid transparent;
                        border-right-width: 10px;
                        border-left-width: 10px;
                        border-bottom: 10px solid $main-black;
                        position: absolute;
                        top: -10px;
                        left: 50%;
                        transform: translate(-50%, 0);
                    }


                }

                &:hover {
                    .tooltip {
                        opacity: 1;
                        pointer-events: auto;
                        transform: translate(-50%, 30px) scale(1, 1);
                    }
                }
            }
        }

        .lock-mask{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba($main-color,0.9);
            opacity: 0;
            pointer-events: none;

            .loading{
                pointer-events: none!important;
            }

            &.show{
                opacity: 1;
                pointer-events: auto;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/ConfigurationItem.vue